<template>
  <div>
    <div id="head-contact" class="bg-grad">
      <h2 class="text-white text-center">
        {{ $t("partenairesReseau.header.title") }}
      </h2>
    </div>

    <section class="section-padding mt-5">
      <div class="container">
        <h2 class="fw-bold display-6 text-primary mb-4">
          {{ $t("partenairesReseau.intro.title") }}
        </h2>

        <p class="text-large mb-4 text-container">
          {{ $t("partenairesReseau.intro.p1") }}
        </p>

        <p class="text-large mb-4">
          {{ $t("partenairesReseau.intro.p2") }}
        </p>

        <div class="row">
          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-people-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item1") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-person-walking text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item2") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-chat-left-dots-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item3") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-bandaid-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item4") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-file-earmark-medical-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item5") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-hospital-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item6") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-hospital text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item7") }}
            </p>
          </div>

          <div class="col-12 d-flex align-items-center mb-3">
            <div class="icon-circle bg-primary me-3 flex-shrink-0">
              <i class="bi bi-briefcase-fill text-white"></i>
            </div>
            <p class="mb-0 text-large">
              {{ $t("partenairesReseau.partners.list.item8") }}
            </p>
          </div>
        </div>

        <p class="text-large mt-4 text-container">
          {{ $t("partenairesReseau.relay.p1") }}
        </p>

        <p class="text-large mt-2 text-container">
          {{ $t("partenairesReseau.relay.p2") }}
        </p>
      </div>
    </section>

    <section class="container my-5">
      <div class="senior-card p-4 p-lg-5">
        <div class="row align-items-center g-4">
          <!-- Texte -->
          <div class="col-lg-8">
            <h2 class="fw-bold text-primary mb-3">
              {{ $t("partenairesReseau.arboresco.title") }}
            </h2>

            <p class="text-xl mb-3">
              {{ $t("partenairesReseau.arboresco.p1") }}
            </p>

            <div class="d-flex flex-wrap gap-2">
              <a
                class="btn btn-primary btn-lg"
                href="https://www.arboresco.be/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t("partenairesReseau.arboresco.buttons.discover") }}
              </a>

              <a
                class="btn btn-outline-primary btn-lg"
                href="https://www.arboresco.be/notre-equipe"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ $t("partenairesReseau.arboresco.buttons.team") }}
              </a>
            </div>
          </div>

          <!-- Logo -->
          <div class="col-lg-4 text-center">
            <div class="partner-logo shadow-sm rounded-4 p-3 bg-white mx-auto">
              <img
                src="@/assets/img/Arboresco.png"
                :alt="$t('partenairesReseau.arboresco.logo.alt')"
                class="img-fluid"
                style="max-height: 300px"
                loading="lazy"
              />
              <p class="mt-2 mb-0">
                {{ $t("partenairesReseau.arboresco.logo.caption") }}
              </p>
              <a
                class="small mt-2 mb-0"
                target="_blank"
                href="https://maps.app.goo.gl/hih2QHP4Uqm1Hyvv5"
              >
                3 Rue Général de Gaulle - 1310 La Hulpe
              </a>
            </div>
          </div>
        </div>

        <hr class="my-4" />

        <h3 class="fw-bold text-primary mb-3">
          {{ $t("partenairesReseau.arboresco.teamTitle") }}
        </h3>

        <div class="row g-3">
          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-chat-square-heart text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item1") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-apple text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item2") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-activity text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item3") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-person-arms-up text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item4") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-person-walking text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item5") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-scissors text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item6") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-mic text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item7") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-person-hearts text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item8") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-hospital text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item9") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-people text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item10") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-brain text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item11") }}
            </div>
          </div>

          <div class="col-lg-6">
            <div class="service-box">
              <i class="bi bi-telephone text-primary me-2"></i>
              {{ $t("partenairesReseau.arboresco.services.item12") }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CALL TO ACTION -->
    <Cta />
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import { useI18n } from "vue-i18n";

import Cta from "@/components/Cta.vue";

export default {
  name: "PartenairesReseau",
  components: {
    Cta,
  },
  setup() {
    const { t } = useI18n();

    useHead(() => ({
      title: t("partenairesReseau.meta-data.title"),
      meta: [
        {
          name: "description",
          content: t("partenairesReseau.meta-data.desc"),
        },
      ],
    }));
  },
};
</script>

<style scoped>
#head-contact {
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle {
  width: 55px;
  height: 55px;
  min-width: 55px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.list-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.list-item {
  align-items: start;
  gap: 15px;
}

/* reprend ton style lisible */
.text-xl {
  font-size: 1.15rem;
  line-height: 1.8;
}

/* si tu utilises déjà senior-card / design global */
.senior-card {
  border-radius: 16px;
  background: #fff;
}

.partner-logo {
  max-width: 320px;
}

.service-box {
  border: 1px solid rgba(13, 110, 253, 0.18);
  border-radius: 12px;
  padding: 14px 16px;
  background: #fff;
  font-size: 1.08rem;
  display: flex;
  align-items: center;
  gap: 6px;
}

@media (max-width: 576px) {
  .service-box {
    font-size: 1.05rem;
    padding: 14px;
  }
}
</style>
